import { render, staticRenderFns } from "./BarraCheckBox.vue?vue&type=template&id=202eff2c&scoped=true&"
import script from "./BarraCheckBox.vue?vue&type=script&lang=js&"
export * from "./BarraCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./BarraCheckBox.vue?vue&type=style&index=0&id=202eff2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202eff2c",
  null
  
)

export default component.exports